import { useRoutes, type RouteObject } from 'react-router';
import { AppLayout } from './AppLayout';
import { ROUTES } from './routes';
import { Placeholder } from '../pages/Placeholder';
import { NotFound } from '../pages/NotFound';
import { OpsDashboard } from '../pages/ops/OpsDashboard';
import { AppSearchPage } from '../pages/search/AppSearchPage';
import { PreviewPage } from '../pages/preview/PreviewPage';
import { VersionsPage } from '../pages/versions/VersionsPage';
import { VocabPage } from '../pages/vocab/VocabPage';
import { ImagesPage } from '../pages/images/ImagesPage';
import { ReviewPage } from '../pages/review/ReviewPage';
import { QaPage } from '../pages/qa/QaPage';

const IMPLEMENTED = new Set(['/', '/versions', '/search', '/preview', '/vocab', '/images', '/review', '/qa']);

export const routeObjects: RouteObject[] = [
  {
    element: <AppLayout />,
    children: [
      { index: true, element: <OpsDashboard /> },
      { path: 'versions', element: <VersionsPage /> },
      { path: 'search', element: <AppSearchPage /> },
      { path: 'vocab', element: <VocabPage /> },
      { path: 'images', element: <ImagesPage /> },
      { path: 'review', element: <ReviewPage /> },
      { path: 'qa', element: <QaPage /> },
      { path: 'preview', element: <PreviewPage /> },
      ...ROUTES.filter((r) => !IMPLEMENTED.has(r.path)).map((r) => ({ path: r.path.slice(1), element: <Placeholder route={r} /> })),
      { path: '*', element: <NotFound /> },
    ],
  },
];

// 데이터 라우터(createBrowserRouter)는 jsdom에서 Request/AbortSignal 구현 차이로 이동이 실패하는 문제가 있어,
// 로더를 쓰지 않는 현재 구조에서는 선언형 라우터 + useRoutes를 사용한다.
export function AppRoutes() {
  return useRoutes(routeObjects);
}
